import { createAction, props } from '@ngrx/store';

export enum UnitCodesActions {
  UnitCodesRequested = '[UnitCodes] UnitCodes Requested',
  UnitCodesLoaded = '[UnitCodes] UnitCodes Loaded',
  UnitCodesError = '[UnitCodes] UnitCodes Error'
}

export const UnitCodesRequested = createAction(UnitCodesActions.UnitCodesRequested);

export const UnitCodesLoaded = createAction(UnitCodesActions.UnitCodesLoaded,
  props<{ unitCodes: any[] }>());

export const UnitCodesError = createAction(UnitCodesActions.UnitCodesError);
